module.exports = __webpack_public_path__ + "img/prioritas_sameday_dg.185d391f.png";